import { FC, useEffect, useState } from "react";
import { Input } from "@/lib/shadcn/ui/input";
import { Label } from "@/lib/shadcn/ui/label";

interface PercentageInputProps {
    id: string;
    label: string;
    value: number;
    onChange: (value: number) => void;
    required?: boolean;
    disabled?: boolean;
}

const PercentageInput: FC<PercentageInputProps> = ({ id, label, value, onChange, required = false, disabled = false }) => {
    const [inputValue, setInputValue] = useState(value.toString());
    const [error, setError] = useState("");

    useEffect(() => {
        setInputValue(value.toString());
    }, [value]);

    const handleChange = (e: any) => {
        const val = e.target.value;

        // Allow empty input temporarily for better UX
        if (val === "") {
            setInputValue("");
            setError("");
            return;
        }

        // Remove any non-numeric characters except for decimal point
        const numericVal = val.replace(/[^\d.]/g, "");
        const numValue = parseFloat(numericVal);

        if (isNaN(numValue)) {
            setInputValue(numericVal);
            setError("Please enter a valid number");
        } else if (numValue < 0 || numValue > 100) {
            setInputValue(numericVal);
            setError("Value must be between 0 and 100");
        } else {
            setInputValue(numericVal);
            setError("");
            onChange(numValue);
        }
    };

    return (
        <div className="space-y-2">
            <Label htmlFor={id}>
                {label}
                {required && "*"}
            </Label>
            <div className="relative">
                <Input id={id} type="text" value={inputValue} onChange={handleChange} disabled={disabled} className={`pr-8 ${error ? "border-red-500" : ""}`} />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">%</div>
            </div>
            {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
    );
};

export default PercentageInput;
